<script lang="ts" setup>
import { computed } from 'vue'

const meta = inject('meta', ref())
const parent = computed(() => meta.value?.parents?.at(-1))

const { public: config } = useRuntimeConfig()
const locale = config.strapiLocale
const strapiData = ref<T | null>()
const strapiError = ref<Error | null | undefined>(null)

const { data: response } = await useAsyncGraphqlQuery('customerServiceDetailPage', {
  documentId: meta?.value?.strapi_id,
  locale,
  status: 'PUBLISHED',
  parentDocumentId: parent.value?.strapi_id,
}, useGraphqlDefaultClient())

strapiData.value = response?.value?.data

if (response?.value?.errors?.length) {
  strapiError.value = response.value.errors
  console.error('getStrapiData', response.value.errors)
}

const { $t } = useI18n()

const pageTitle = computed(
  () => strapiData.value?.page?.PageTitle || '',
)

const metaTitle = computed(
  () => strapiData.value?.page?.MetaData?.MetaTitle || pageTitle.value + ' | ' + $t('meta.title'),
)

const metaDescription = computed(
  () => strapiData.value?.page?.MetaData?.MetaDescription || $t('meta.description'),
)

const { setBreadcrumbs } = useBreadcrumbs()
setBreadcrumbs({
  label: pageTitle.value,
  parents: meta.value?.parents,
})

const { pageView } = useDataLayer()

if (meta.value?.label === '404') {
  pageView('404', metaTitle.value)
}
else {
  pageView('cms', metaTitle.value)
}

useHead({
  title: metaTitle,
  meta: [
    { name: 'description', content: metaDescription },
    { name: 'robots', content: strapiData.value?.page?.MetaData?.MetaRobots?.replace('_', ', ') },
  ],
  script: [
    { type: 'application/ld+json', key: 'RichSnippets', innerHTML: strapiData.value?.page?.MetaData?.RichSnippets || '' },
  ],
})

const route = useRoute()
const { canonical } = useSeo()
canonical(computed(() => route.path))

const ContentTypes = ['ComponentSlicesFaq', 'ComponentSlicesButtons']

const faqSlices = computed(() => strapiData.value?.page?.Slices?.filter((slice: any) => ContentTypes.includes(slice.__typename)) || [])
const otherSlices = computed(() => strapiData.value?.page?.Slices?.filter((slice: any) => !ContentTypes.includes(slice.__typename)) || [])
</script>

<template>
  <div>
    <div
      v-if="strapiData"
      class="customer-service-detail"
    >
      <!-- Disabled for home -->
      <AppBreadcrumbs v-if="$route.path !== '/'" />

      <div class="customer-service-detail__container">
        <CmsDropdownMenu
          v-if="strapiData?.pages?.length"
          class="customer-service-detail__menu"
          :pages="strapiData.pages"
        />

        <div class="customer-service-detail__content">
          <UiHeading
            force-tag="h1"
            class="customer-service-detail__heading"
          >
            {{ strapiData.page.PageTitle }}
          </UiHeading>

          <UiHeadingSection>
            <StrapiSlices
              v-if="faqSlices?.length"
              :slices="faqSlices"
            />
          </UiHeadingSection>
        </div>
      </div>

      <UiHeadingSection>
        <StrapiSlices
          v-if="otherSlices?.length"
          :slices="otherSlices"
        />
      </UiHeadingSection>
    </div>

    

    <slot />

    <!--  -->
    <!--  -->
    <!--  -->
    <!--  -->
  </div>
</template>

<style>
@import url("~layers/pages/~cms.css");
@import url("~layers/pages/~customer-service-detail.css");
</style>
